import { FormEventsState } from '../types';

export const defaultFormEventsState: FormEventsState = {
  'Form loaded but invisible': 'waiting',
  'Form visible': 'waiting',
  'Name field interaction': 'waiting',
  'Email field interaction': 'waiting',
  'Phone field interaction': 'waiting',
  'Check interaction': 'waiting',
  'Dropdown interaction': 'waiting',
  'Check privacy policy': 'waiting',
  'Click on submit button': 'waiting',
  'Form submitted success': 'waiting',
  'Form submitted failed': 'waiting',
  'Email validation error': 'waiting',
  'Form field interactions updated': 'waiting',
  'File upload failed': 'waiting',
};

// этот список используется в функции getActualSfConfig
export const countriesToChangeLang = [
  {
    code: 'AZ',
    phoneCode: '+994',
  },
  {
    code: 'KG',
    phoneCode: '+996',
  },
  {
    code: 'KZ',
    phoneCode: '+77',
  },
  {
    code: 'TM',
    phoneCode: '+993',
  },
  {
    code: 'TJ',
    phoneCode: '+992',
  },
  {
    code: 'UA',
    phoneCode: '+380',
  },
  {
    code: 'UZ',
    phoneCode: '+998',
  },
  {
    code: 'IL',
    phoneCode: '+972',
  },
  {
    code: 'LV',
    phoneCode: '+371',
  },
  {
    code: 'PL',
    phoneCode: '+48',
  },
  {
    code: 'ES',
    phoneCode: '+346',
  },
  {
    code: 'US',
    phoneCode: '+1',
  },
];
